import React from "react"
import { AppBar, Box, Drawer, Fab } from "@mui/material"
import { BrowserView, MobileView } from "react-device-detect"
import ListItems from "./ListItems"
import capitalAdvertisement from "../public/Advertising/5.jpg"
import { Menu } from "@mui/icons-material"
import Transition from "../utils/Transition"
import BrandingService from "../branding/BrandingService"

const delay = ms => new Promise(res => setTimeout(res, ms))

export default function Sidebar({ mid, dba, merchantSettings }) {
  // States
  const [open, setOpen] = React.useState(false)
  const [capital, setCapital] = React.useState(false)

  // Effects
  React.useEffect(() => {
    const func = async () => { await delay(1000); setCapital(true) }
    func()
  }, [])

  return (
    <>
      <BrowserView>
        <Drawer
          variant="permanent"
          sx={{ width: 239.7, maxWidth: 239.7, borderRightWidth: 0 }}
          PaperProps={{
            elevation: 5,
            sx: {
              bgcolor: "",
              color: "",
              scrollbarWidth: "none",
              borderRightWidth: 0
            }
          }}>
          <AppBar position="sticky" elevation={0} sx={{ bgcolor: "white" }}>
            <Box display="flex" justifyContent="center" padding={1}>
              <img src={BrandingService.current.logo} alt="" style={{ maxWidth: "200px", maxHeight: "80px" }} />
            </Box>
          </AppBar>
          <ListItems setOpen={setOpen} mid={mid} dba={dba} merchantSettings={merchantSettings} />
          {BrandingService.current.advertisement &&
            <Transition when={capital} type="fade">
              <Box display="flex" alignContent="center" justifyContent="center" paddingBottom={1} paddingX={1}>
                <a href="https://www.unitedcapitalsource.com/lp-paradise-pos-v3/?utm_source=paradise_pos&utm_medium=referral&utm_campaign=business_loans">
                  <img src={BrandingService.current.advertisement} alt="" width={216} />
                </a>
              </Box>
            </Transition>}
        </Drawer>
      </BrowserView>
      <MobileView>
        <Fab
          color="primary"
          onClick={() => setOpen(true)}
          sx={{ position: "fixed", bottom: 16, right: 16 }}
        >
          <Menu />
        </Fab>
        <Drawer anchor="left" open={open} onOpen={() => setOpen(true)} onClose={() => setOpen(false)} keepMounted={true}>
          <Box display="flex" justifyContent="center" padding={1}>
            <img src={BrandingService.current.logo} alt="" style={{ maxWidth: "200px", maxHeight: "80px" }} />
          </Box>
          <ListItems setOpen={setOpen} mid={mid} dba={dba} merchantSettings={merchantSettings} />
          {BrandingService.current.advertisement &&
            <Box display="flex" alignContent="center" justifyContent="center" paddingBottom={1} paddingX={1}>
              <a href="https://www.unitedcapitalsource.com/lp-paradise-pos-v3/?utm_source=paradise_pos&utm_medium=referral&utm_campaign=business_loans">
                <img src={BrandingService.current.advertisement} alt="" width={216} />
              </a>
            </Box>}
        </Drawer>
      </MobileView>
    </>
  )
}